import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { NOT_FOUND_PAGE, ERROR_PAGE, PAGES } from './constants/pages';

import NotFoundPage from './pages/ErrorPages/NotFoundPage';
import ErrorPage from './pages/ErrorPages/ErrorPage';

import PrivateRoute from './components/Router/PrivateRoute';
import {
  APPLICANT_TYPES,
  DOCUMENT_TYPES,
  REGISTRATION_FLOW_TYPES,
} from './util/constants';

import KycProofOfIdentity from './pages/KycVerification/KycProofOfIdentity';
import KycProofOfResidency from './pages/KycVerification/KycProofOfResidency';
import KycUploadIdentityDocuments from './pages/KycVerification/KycUploadIdentityDocuments';
import KycUploadIdentityDocumentsViaWebcam from './pages/KycVerification/KycUploadIdentityDocumentsViaWebcam';
import KycUploadResidencyDocument from './pages/KycVerification/KycUploadResidencyDocument';
import KycUploadOwnershipDocument from './pages/KycVerification/KycUploadOwnershipDocument';
import KycUploadMethod from './pages/KycVerification/KycUploadMethod';
import WelcomeFluentEmail from './pages/WelcomeFluentEmail';
import PrepareRegistration from './pages/PrepareRegistration/PrepareRegistration';
import Login from './pages/Login';
import ResetSent from './pages/ResetSent';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CreateApplication from './pages/CreateApplication/CreateApplication';
import CreateApplicationStandard from './pages/CreateApplication/CreateApplicationStandard';
import CreateApplicationRetirement from './pages/CreateApplication/CreateApplicationRetirement';
import CreateApplicationRetirementPersonal from './pages/CreateApplication/CreateApplicationRetirementPersonal';
import CreateApplicationRetirementBusiness from './pages/CreateApplication/CreateApplicationRetirementBusiness';
import CreateApplicationUtma from './pages/CreateApplication/CreateApplicationUtma';
import CreateAccount from './pages/CreateAccount';
import LoadingPage from './pages/LoadingPage';
import LoginUserLoadingPage from './pages/LoginUserLoadingPage';
import SecureAccount from './pages/Account/SecureAccount';
import ChooseApplication from './pages/ChooseApplication/ChooseApplication';
import ChooseApplicationStandard from './pages/ChooseApplication/ChooseApplicationStandard';
import ChooseApplicationRetirement from './pages/ChooseApplication/ChooseApplicationRetirement';
import ChooseApplicationRetirementBusiness from './pages/ChooseApplication/ChooseApplicationRetirementBusiness';
import ChooseApplicationRetirementPersonal from './pages/ChooseApplication/ChooseApplicationRetirementPersonal';
import ChooseApplicationUtma from './pages/ChooseApplication/ChooseApplicationUtma';
import VerifyBusinessType from './pages/Business/VerifyBusinessType';
import VerifyBusinessName from './pages/Business/VerifyBusinessName';
import VerifyBusinessEin from './pages/Business/VerifyBusinessEin';
import AddressEnter from './pages/Address/AddressEnter';
import BusinessReview from './pages/Review/BusinessReview';
import SecureAccountName from './pages/Account/SecureAccountName';
import SecureAccountDob from './pages/Account/SecureAccountDob';
import SecureAccountIdentity from './pages/Account/SecureAccountIdentity';
import SecureAccountSSN from './pages/Account/SecureAccountSSN';
import SecureAccountVerification from './pages/Account/SecureAccountID';

import SecureAccountPhoneNumber from './pages/Account/SecureAccountPhoneNumber';
import MetalStream from './pages/MetalStream/MetalStream';
import MetalStreamInvest from './pages/MetalStream/MetalStreamInvest';
import MetalStreamAllocate from './pages/MetalStream/MetalStreamAllocate';
import MetalStreamGold from './pages/MetalStream/MetalStreamGold';
import MetalStreamSilver from './pages/MetalStream/MetalStreamSilver';
import MetalStreamReview from './pages/MetalStream/MetalStreamReview';
import SecureAccountTrustName from './pages/Account/SecureAccountTrustName';
import SecureAccountEinQuestion from './pages/Account/SecureAccountEinQuestion';
import SecureAccountEin from './pages/Account/SecureAccountEin';

import FundMetal from './pages/Funding/FundMetal';
import FundJointSurvivor from './pages/Funding/FundJointSurvivor';
import Review from './pages/Review/Review';
import Agreement from './pages/Review/Agreement';
import SecureAccountRetirementBusinessName from './pages/Account/SecureAccountRetirementBusinessName';
import SecureAccountRetirementMaritalStatus from './pages/Account/SecureAccountRetirementMaritalStatus';
import FundAccount from './pages/Funding/FundAccount';
import FundRetirement from './pages/Funding/FundRetirement';
import FundAmount from './pages/Funding/FundAmount';
import FundRetirementAmount from './pages/Funding/FundRetirementAmount';
import EquityAgreement from './pages/Review/EquityAgreement';
import KycProcessing from './pages/Kyc/KycProcessing';
import KycSuccess from './pages/Kyc/KycSuccess';
import KycVerification from './pages/Kyc/KycVerification';
import SecureAddress from './pages/Address/SecureAddress';
import KycDone from './pages/Kyc/KycDone';
import SecureAddressSecondOwner from './pages/Address/SecureAddressSecondOwner';
import AddressDone from './pages/Address/AddressDone';
import DeleteApplicationPage from './pages/DeleteApplicationPage/DeleteApplicationPage';
import MetalStreamSummary from './pages/MetalStream/MetalStreamSummary';
import ResetSuccessfulPage from './pages/ResetSuccessfulPage';
import SalesAssistedInviteUser from './pages/SalesAssistedInviteUser/SalesAssistedInviteUser';
import SetPasswordPage from './pages/SetPasswordPage';
import SalesAssistedImpersonate from './pages/SalesAssistedImpersonate/SalesAssistedImpersonate';
import EmploymentStatus from './pages/EmploymentStatus/EmploymentStatus';
import FundRetirementSource from './pages/Funding/FundRetirementSource';
import KycUploadSocialSecurityDocuments from './pages/KycVerification/KycUploadSocialSecurityDocuments';
import KycUploadSocialSecurityDocumentsViaWebcam from './pages/KycVerification/KycUploadSocialSecurityDocumentsViaWebcam';
import KycSSCUploadMethod from './pages/KycVerification/KycSSCUploadMethod';

const AppRoutes = () => (
  <Switch>
    <Route exact path={PAGES.BASE}>
      <WelcomeFluentEmail
        registrationFlowType={REGISTRATION_FLOW_TYPES.REGULAR}
      />
    </Route>
    <Route exact path={PAGES.AIP}>
      <WelcomeFluentEmail registrationFlowType={REGISTRATION_FLOW_TYPES.AIP} />
    </Route>
    <Route
      exact
      path={PAGES.PREPARE_REGISTRATION}
      component={PrepareRegistration}
    />
    <Route exact path={PAGES.LOGIN_PATH} component={Login} />
    <Route exact path={PAGES.RESET_SENT} component={ResetSent} />
    <Route exact path={PAGES.RESET_PASSWORD} component={ResetPasswordPage} />
    <Route exact path={PAGES.SET_PASSWORD} component={SetPasswordPage} />
    <Route exact path={PAGES.INVITE_USER} component={SalesAssistedInviteUser} />
    <Route
      exact
      path={PAGES.IMPERSONATE}
      component={SalesAssistedImpersonate}
    />
    <Route
      exact
      path={PAGES.RESET_SUCCESSFUL_PAGE}
      component={ResetSuccessfulPage}
    />
    <Route
      exact
      path={PAGES.CREATE_APPLICATION.MAIN}
      component={CreateApplication}
    />
    <Route
      exact
      path={PAGES.CREATE_APPLICATION.STANDARD.MAIN}
      component={CreateApplicationStandard}
    />
    <Route
      exact
      path={PAGES.CREATE_APPLICATION.RETIREMENT.MAIN}
      component={CreateApplicationRetirement}
    />
    <Route
      exact
      path={PAGES.CREATE_APPLICATION.RETIREMENT.PERSONAL}
      component={CreateApplicationRetirementPersonal}
    />
    <Route
      exact
      path={PAGES.CREATE_APPLICATION.RETIREMENT.BUSINESS}
      component={CreateApplicationRetirementBusiness}
    />
    <Route
      exact
      path={PAGES.CREATE_APPLICATION.UTMA.MAIN}
      component={CreateApplicationUtma}
    />
    <Route exact path={PAGES.CREATE_ACCOUNT} component={CreateAccount} />
    <Route exact path={PAGES.LOADING} component={LoadingPage} />
    <Route
      exact
      path={PAGES.REFRESH_LOADING}
      component={LoginUserLoadingPage}
    />
    <PrivateRoute exact path={PAGES.SECURE_ACCOUNT} component={SecureAccount} />
    <PrivateRoute
      exact
      path={PAGES.CHOOSE_APPLICATION.MAIN}
      component={ChooseApplication}
    />
    <PrivateRoute
      exact
      path={PAGES.CHOOSE_APPLICATION.STANDARD.MAIN}
      component={ChooseApplicationStandard}
    />
    <PrivateRoute
      exact
      path={PAGES.CHOOSE_APPLICATION.RETIREMENT.MAIN}
      component={ChooseApplicationRetirement}
    />
    <PrivateRoute
      exact
      path={PAGES.CHOOSE_APPLICATION.RETIREMENT.BUSINESS}
      component={ChooseApplicationRetirementBusiness}
    />
    <PrivateRoute
      exact
      path={PAGES.CHOOSE_APPLICATION.RETIREMENT.PERSONAL}
      component={ChooseApplicationRetirementPersonal}
    />
    <PrivateRoute
      exact
      path={PAGES.CHOOSE_APPLICATION.UTMA.MAIN}
      component={ChooseApplicationUtma}
    />
    {/* Verify business */}
    <PrivateRoute
      exact
      path={PAGES.BUSINESS_ACCOUNT.SECURE_ACCOUNT}
      component={SecureAccount}
    />
    <PrivateRoute
      exact
      path={PAGES.SECURE_BUSINESS_TYPE}
      component={VerifyBusinessType}
    />
    <PrivateRoute
      exact
      path={PAGES.SECURE_BUSINESS_ORIGIN_NAME}
      component={VerifyBusinessName}
    />
    <PrivateRoute
      exact
      path={PAGES.SECURE_BUSINESS_ORIGIN_EIN}
      component={VerifyBusinessEin}
    />
    <PrivateRoute exact path={PAGES.SECURE_BUSINESS_ADDRESS}>
      <AddressEnter applicantType={APPLICANT_TYPES.BUSINESS} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_BUSINESS_REVIEW}>
      <BusinessReview applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.BUSINESS_ACCOUNT.SECURE_NAME}>
      <SecureAccountName applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.BUSINESS_ACCOUNT.SECURE_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.BUSINESS_ACCOUNT.SECURE_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY}>
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.BUSINESS_ACCOUNT.SECURE_IDENTITY_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.BUSINESS_ACCOUNT.SECURE_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    {/* Metal Stream */}
    <Route exact path={PAGES.METAL_STREAM} component={WelcomeFluentEmail} />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_WELCOME}
      component={MetalStream}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_MONTHLY_INVEST}
      component={MetalStreamInvest}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_FUND_ALLOCATION}
      component={MetalStreamAllocate}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_GOLD}
      component={MetalStreamGold}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_SILVER}
      component={MetalStreamSilver}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_REVIEW}
      component={MetalStreamReview}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_STREAM_SUMMARY}
      component={MetalStreamSummary}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_ACCOUNT}
      component={SecureAccount}
    />
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_NAME}>
      <SecureAccountName applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_IDENTITY}>
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_IDENTITY_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_IDENTITY_DETAILS}>
      <SecureAccountVerification applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.EMPLOYMENT_STATUS}>
      <EmploymentStatus applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    {/* Metal minor info */}
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_MINOR}>
      <SecureAccountName applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_MINOR_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_MINOR_IDENTITY}>
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_MINOR_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    {/* Metal business info */}
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_BUSINESS_TYPE}
      component={VerifyBusinessType}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_BUSINESS_ORIGIN_NAME}
      component={VerifyBusinessName}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_BUSINESS_ORIGIN_EIN}
      component={VerifyBusinessEin}
    />
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_BUSINESS_ADDRESS}
    >
      <AddressEnter applicantType={APPLICANT_TYPES.BUSINESS} />
    </PrivateRoute>
    {/* Metal trust info */}
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_TRUST_NAME}>
      <SecureAccountTrustName />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_TRUST_NAME_EIN_QUESTION}
    >
      <SecureAccountEinQuestion />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_TRUST_NAME_EIN}>
      <SecureAccountEin />
    </PrivateRoute>
    {/* Metal Secondary owner */}
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_SECONDARY}>
      <SecureAccountName applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_SECONDARY_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_SECONDARY_PHONE_NUMBER}
    >
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.METAL_SECURE_ACCOUNT.SECURE_SECONDARY_IDENTITY}
    >
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.SECURE_SECONDARY_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.FUNDING.METALSTREAM_FUNDING.ACCOUNT}
      component={FundMetal}
    />
    <PrivateRoute
      exact
      path={PAGES.FUNDING.NORMAL_FUNDING.JOINT_METAL_SURVIVOR}
    >
      <FundJointSurvivor />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.REVIEW}>
      <Review isMetal />
    </PrivateRoute>

    <PrivateRoute exact path={PAGES.METAL_SECURE_ACCOUNT.AGREEMENT}>
      <Agreement isMetal />
    </PrivateRoute>
    {/* Main owner */}
    <PrivateRoute exact path={PAGES.SECURE_BUSINESS_NAME}>
      <SecureAccountRetirementBusinessName />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_TRUST_NAME}>
      <SecureAccountTrustName />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_TRUST_NAME_EIN_QUESTION}>
      <SecureAccountEinQuestion />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_TRUST_NAME_EIN}>
      <SecureAccountEin />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_NAME}>
      <SecureAccountName applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_MARITAL}>
      <SecureAccountRetirementMaritalStatus />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_IDENTITY}>
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_IDENTITY_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT}>
      <FundAccount />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT}>
      <FundRetirement />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FINANCIAL_PROFILE}>
      <FundRetirementSource />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.PLAID}>
      <FundAmount />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.WIRE}>
      <FundAmount />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CHECK}>
      <FundAmount />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CRYPTOCURRENCY}
    >
      <FundAmount />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.RETIREMENT_FUNDING.AMOUNT.ROLLOVER}>
      <FundRetirementAmount />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.FUNDING.RETIREMENT_FUNDING.AMOUNT.ANNUAL_CONTRIBUTION}
    >
      <FundRetirementAmount />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR}>
      <FundJointSurvivor />
    </PrivateRoute>
    {/* Secondary owner */}
    <PrivateRoute exact path={PAGES.SECURE_SECONDARY}>
      <SecureAccountName applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_SECONDARY_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_SECONDARY_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_SECONDARY_IDENTITY}>
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_SECONDARY_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>

    {/* Minor owner */}
    <PrivateRoute exact path={PAGES.SECURE_MINOR}>
      <SecureAccountName applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_MINOR_DOB}>
      <SecureAccountDob applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_MINOR_PHONE_NUMBER}>
      <SecureAccountPhoneNumber applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_MINOR_IDENTITY}>
      <SecureAccountIdentity applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.SECURE_MINOR_SSN}>
      <SecureAccountSSN applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.REVIEW}>
      <Review />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.AGREEMENT}>
      <Agreement />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.EQUITY_AGREEMENT}>
      <EquityAgreement />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.KYC_PROCESSING} component={KycProcessing} />
    <PrivateRoute exact path={PAGES.KYC_SUCCESS} component={KycSuccess} />
    <PrivateRoute
      exact
      path={PAGES.KYC_VERIFICATION}
      component={KycVerification}
    />
    {/* KYC */}
    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.MAIN}>
      <KycProofOfIdentity applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.MAIN}>
      <KycProofOfIdentity applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.MAIN}>
      <KycProofOfIdentity applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD.DRIVERS_LICENSE}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD.GOVERNMENT_ID}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD.PASSPORT}>
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD.DRIVERS_LICENSE}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD.GOVERNMENT_ID}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD.PASSPORT}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD.DRIVERS_LICENSE}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD.GOVERNMENT_ID}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD.PASSPORT}
    >
      <KycUploadMethod
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD_FILE.DRIVERS_LICENSE}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD_FILE.GOVERNMENT_ID}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD_FILE.PASSPORT}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD_FILE.DRIVERS_LICENSE}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD_FILE.GOVERNMENT_ID}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD_FILE.PASSPORT}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD_FILE.DRIVERS_LICENSE}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD_FILE.GOVERNMENT_ID}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD_FILE.PASSPORT}
    >
      <KycUploadIdentityDocuments
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD_CAMERA.DRIVERS_LICENSE}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD_CAMERA.GOVERNMENT_ID}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MAIN.UPLOAD_CAMERA.PASSPORT}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD_CAMERA.DRIVERS_LICENSE}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD_CAMERA.GOVERNMENT_ID}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.SECONDARY.UPLOAD_CAMERA.PASSPORT}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD_CAMERA.DRIVERS_LICENSE}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.DRIVERS_LICENSE}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD_CAMERA.GOVERNMENT_ID}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.GOVERNMENT_ID}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_IDENTITY.MINOR.UPLOAD_CAMERA.PASSPORT}
    >
      <KycUploadIdentityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.PASSPORT}
      />
    </PrivateRoute>

    {/* Main Social Security */}
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.MAIN.UPLOAD.SOCIAL_SECURITY_CARD}
      applicantType={APPLICANT_TYPES.MAIN}
    >
      <KycSSCUploadMethod
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.SECONDARY.UPLOAD.SOCIAL_SECURITY_CARD
      }
      applicantType={APPLICANT_TYPES.SECONDARY}
    >
      <KycSSCUploadMethod
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.MINOR.UPLOAD.SOCIAL_SECURITY_CARD
      }
      applicantType={APPLICANT_TYPES.MINOR}
    >
      <KycSSCUploadMethod
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    {/* Main Social Security - Upload File */}
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.MAIN.UPLOAD_FILE.SOCIAL_SECURITY_CARD
      }
    >
      <KycUploadSocialSecurityDocuments
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    {/* Secondary Social Security - Upload File */}
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.SECONDARY.UPLOAD_FILE
          .SOCIAL_SECURITY_CARD
      }
    >
      <KycUploadSocialSecurityDocuments
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    {/* Minor Social Security - Upload File */}
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.MINOR.UPLOAD_FILE
          .SOCIAL_SECURITY_CARD
      }
    >
      <KycUploadSocialSecurityDocuments
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    {/* Main Social Security - Camera */}
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.MAIN.UPLOAD_CAMERA
          .SOCIAL_SECURITY_CARD
      }
    >
      <KycUploadSocialSecurityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    {/* Secondary Social Security - Camera */}
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.SECONDARY.UPLOAD_CAMERA
          .SOCIAL_SECURITY_CARD
      }
    >
      <KycUploadSocialSecurityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>
    {/* Minor Social Security - Camera */}
    <PrivateRoute
      exact
      path={
        PAGES.KYC_PROOF_OF_SOCIAL_SECURITY.MINOR.UPLOAD_CAMERA
          .SOCIAL_SECURITY_CARD
      }
    >
      <KycUploadSocialSecurityDocumentsViaWebcam
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.SOCIAL_SECURITY_CARD}
      />
    </PrivateRoute>

    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_RESIDENCE.MAIN.MAIN}>
      <KycProofOfResidency applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_RESIDENCE.SECONDARY.MAIN}>
      <KycProofOfResidency applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_RESIDENCE.MINOR.MAIN}>
      <KycProofOfResidency applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MAIN.UPLOAD.CREDIT_CARD_STATEMENT}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.CREDIT_CARD}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MAIN.UPLOAD.UTILITY_BILL}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.UTILITY_BILL}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MAIN.UPLOAD.BANK_STATEMENT}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.BANK_STATEMENT}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MAIN.UPLOAD.VOIDED_CHECK}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.VOIDED_CHECK}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.SECONDARY.UPLOAD.CREDIT_CARD_STATEMENT}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.CREDIT_CARD}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.SECONDARY.UPLOAD.UTILITY_BILL}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.UTILITY_BILL}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.SECONDARY.UPLOAD.BANK_STATEMENT}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.BANK_STATEMENT}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.SECONDARY.UPLOAD.VOIDED_CHECK}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.SECONDARY}
        documentType={DOCUMENT_TYPES.VOIDED_CHECK}
      />
    </PrivateRoute>

    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MINOR.UPLOAD.CREDIT_CARD_STATEMENT}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.CREDIT_CARD}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MINOR.UPLOAD.UTILITY_BILL}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.UTILITY_BILL}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MINOR.UPLOAD.BANK_STATEMENT}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.BANK_STATEMENT}
      />
    </PrivateRoute>
    <PrivateRoute
      exact
      path={PAGES.KYC_PROOF_OF_RESIDENCE.MINOR.UPLOAD.VOIDED_CHECK}
    >
      <KycUploadResidencyDocument
        applicantType={APPLICANT_TYPES.MINOR}
        documentType={DOCUMENT_TYPES.VOIDED_CHECK}
      />
    </PrivateRoute>

    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_OWNERSHIP.UPLOAD}>
      <KycUploadOwnershipDocument />
    </PrivateRoute>

    <PrivateRoute exact path={PAGES.KYC_PROOF_OF_OWNERSHIP.MAIN}>
      <KycUploadOwnershipDocument
        applicantType={APPLICANT_TYPES.MAIN}
        documentType={DOCUMENT_TYPES.CREDIT_CARD}
      />
    </PrivateRoute>

    {/* KYC */}
    <PrivateRoute
      exact
      path={PAGES.KYC_VERIFICATION}
      component={KycVerification}
    />
    <PrivateRoute exact path={PAGES.KYC_DONE} component={KycDone} />
    <PrivateRoute exact path={PAGES.KYC_DONE_SKIP} component={KycDone} />
    <PrivateRoute exact path={PAGES.ADDRESS}>
      <SecureAddress applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>

    <PrivateRoute exact path={PAGES.ADDRESS_ENTER}>
      <AddressEnter applicantType={APPLICANT_TYPES.MAIN} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.ADDRESS_SECONDARY}>
      <SecureAddressSecondOwner applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.ADDRESS_SECONDARY_ENTER}>
      <AddressEnter applicantType={APPLICANT_TYPES.SECONDARY} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.ADDRESS_MINOR}>
      <SecureAddressSecondOwner applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.ADDRESS_MINOR_ENTER}>
      <AddressEnter applicantType={APPLICANT_TYPES.MINOR} />
    </PrivateRoute>
    <PrivateRoute exact path={PAGES.ADDRESS_DONE} component={AddressDone} />
    <Route path={PAGES.DELETE_APPLICATION} component={DeleteApplicationPage} />
    <Route path={NOT_FOUND_PAGE} component={NotFoundPage} />
    <Route path={ERROR_PAGE} component={ErrorPage} />
    <Redirect from="*" to={NOT_FOUND_PAGE} />
  </Switch>
);
export default AppRoutes;
